import { FormControl, FormGroup, Validators } from '@angular/forms';
// import { GenderType } from '@domain/model/enums/personal-data/gender.enum';
// import { MaritalStatus } from '@domain/model/enums/personal-data/maritalStatus.enum';
import { createAddressForm } from '../../../address-form/address.form';
import { IBaseFormBuilder } from '../../builders/base-builder.class';
import { BIRTHDAY_VALIDATORS } from '../../common-fields/birthday.field';

export class ConfigLegalPersonNoClientBuilder implements IBaseFormBuilder {
  private form!: FormGroup;
  isSameAddress: boolean;
  constructor(isSameAddress: boolean) {
    this.isSameAddress = isSameAddress;
  }
  build(): void {
    this.form = new FormGroup({
      birthday: new FormControl('', BIRTHDAY_VALIDATORS),
      // gender: new FormControl(GenderType.MASCULINO, [Validators.required]),
      // maritalStatus: new FormControl(MaritalStatus.SOLTERO, [Validators.required]),
      gender: new FormControl('', [Validators.required]),
      maritalStatus: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^9/)]),
      phoneNumberStandarized: new FormControl(false),
      phoneCarrier: new FormControl('', [Validators.required]),
      isSameAddress: new FormControl(this.isSameAddress),
      address: createAddressForm(),
    });
    this.addPersonalFields();
  }

  getResult(): FormGroup {
    return this.form;
  }

  private addPersonalFields() {
    this.form.addControl(
      'personalData',
      new FormGroup({
        isPEP: new FormControl(false, [Validators.required]),
      })
    );
  }
}
